import { useMemo } from "react";

export const usePlatform = () => {
  const isMacOS = useMemo(() => {
    const userAgent = window.navigator.userAgent;
    return (
      userAgent.includes("Mac OS X") ||
      userAgent.includes("Macintosh") ||
      userAgent.includes("MacIntel")
    );
  }, []);

  const getModifierKey = () => {
    return isMacOS ? "⌘" : "Ctrl";
  };

  const getModifierKeyName = () => {
    return isMacOS ? "Cmd" : "Ctrl";
  };

  const formatShortcut = (key) => {
    return `${getModifierKey()}+${key.toUpperCase()}`;
  };

  return {
    isMacOS,
    isWindows: !isMacOS,
    modifierKey: getModifierKey(),
    modifierKeyName: getModifierKeyName(),
    formatShortcut,
  };
};